module.exports = __webpack_public_path__ + "img/spin_btn.00fd0dac.png";